var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartsenseLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_smartsense",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_rectangle_copy_4",
    "data-name": "Rounded rectangle copy 4",
    width: 32,
    height: 32,
    rx: 2.921,
    fill: "#19838c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    transform: "translate(-10.358 -12.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(19.33 26.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    d: "M7.8.733c.8-.266,1.6-.94,2.258-.665a7.37,7.37,0,0,1,4.322,7.084c0,1.336-3.627,1.022-7.235,1.008C3.564,8.145,0,8.368,0,7.152A7.914,7.914,0,0,1,2.88.97,5.26,5.26,0,0,1,4.336.061c.683-.285,1.4.506,2.222.722A2.711,2.711,0,0,0,7.8.733Z",
    transform: "translate(0 7.57)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M53.321,53.915a3.342,3.342,0,1,0,3.342,3.342A3.342,3.342,0,0,0,53.321,53.915Z",
    transform: "translate(-46.153 -53.915)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(20.419 14.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    transform: "translate(2.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M49.466,15.338h0a.8.8,0,0,1,1.021-.233,3.526,3.526,0,0,0,4.753-.041.662.662,0,0,1,.89.043l.069.071a.709.709,0,0,1-.07,1.051,4.916,4.916,0,0,1-6.51.058A.708.708,0,0,1,49.466,15.338Z",
    transform: "translate(-49.345 -14.913)",
    fill: "#f3f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156",
    transform: "translate(0 2.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M40.793,24.637l.069-.072a.655.655,0,0,1,.907-.044c3.175,2.791,6.8,2.753,9.923-.1a.655.655,0,0,1,.907.027l.068.07a.707.707,0,0,1-.028,1.016c-3.658,3.341-8.083,3.386-11.8.12A.707.707,0,0,1,40.793,24.637Z",
    transform: "translate(-40.6 -24.25)",
    fill: "#f3f4f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(12.101 22.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    transform: "translate(0 2.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M12.408,57.757h0a.8.8,0,0,1-.194-1.029,3.526,3.526,0,0,0,.14-4.751.662.662,0,0,1,.077-.888l.073-.067a.71.71,0,0,1,1.048.11,4.916,4.916,0,0,1-.188,6.507A.708.708,0,0,1,12.408,57.757Z",
    transform: "translate(-12.101 -50.841)",
    fill: "#f3f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(2.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M21.405,54.137l-.07-.071a.655.655,0,0,1-.01-.908c2.909-3.067,3.009-6.688.275-9.92a.655.655,0,0,1,.062-.906l.072-.066a.707.707,0,0,1,1.015.067c3.2,3.782,3.077,8.206-.327,11.794A.707.707,0,0,1,21.405,54.137Z",
    transform: "translate(-21.148 -42.084)",
    fill: "#f3f4f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    transform: "translate(34.524 22.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(3.41 2.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M102.642,50.421h0a.8.8,0,0,1,.271,1.011,3.526,3.526,0,0,0,.214,4.749.662.662,0,0,1-.011.89l-.068.072a.709.709,0,0,1-1.053-.032,4.916,4.916,0,0,1-.3-6.5A.708.708,0,0,1,102.642,50.421Z",
    transform: "translate(-100.611 -50.313)",
    fill: "#f3f4f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M92.151,42.1l.075.066a.655.655,0,0,1,.077.9c-2.673,3.275-2.5,6.893.463,9.913a.655.655,0,0,1,.006.908l-.067.071a.707.707,0,0,1-1.017.009c-3.473-3.533-3.679-7.954-.55-11.786A.707.707,0,0,1,92.151,42.1Z",
    transform: "translate(-88.929 -41.924)",
    fill: "#f3f4f4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsenseLogo);
export default __webpack_public_path__ + "static/media/smartsense-logo.c4d69566cb5a968233cb8591e159d419.svg";
export { ForwardRef as ReactComponent };